import {
    AlertDialog,
    AlertDialogOverlay,
    AlertDialogContent,
    AlertDialogBody,
    AlertDialogFooter,
    Button,
    Text,
} from '@chakra-ui/react';
import React, { useEffect, useRef } from 'react';
import { usePengetahuanDetailContext } from '../../controller/pengetahuan/detail';
import confetti from 'canvas-confetti';
import { useHistory } from 'react-router-dom';

const ModalSuccessKlinikKhusus = () => {
    const history = useHistory();
    const { setPengetahuanDetailState: setState } =
        usePengetahuanDetailContext();

    const { pengetahuanItem, isOpenModalSuccessKlinikKhusus, loadingChangeStatusPengetahuan } =
        usePengetahuanDetailContext().state;

    const cancelRef = useRef(null);
    const canvasRef = useRef<HTMLCanvasElement | null>(null);

    const onClose = () => {
        setState('isOpenModalSuccessKlinikKhusus', false);
    };

    const handleNext = () => {
        history.push(`/detail/pengetahuan/${pengetahuanItem?.parent_id}`);
        onClose();
    };


    useEffect(() => {
        if (isOpenModalSuccessKlinikKhusus) {
            setTimeout(() => {
                if (canvasRef.current) {
                    const myConfetti = confetti.create(canvasRef.current, {
                        resize: true,
                        useWorker: true,
                    });
        
                    myConfetti({
                        particleCount: 500,
                        spread: 120,
                        origin: { y: 0.6 },
                    });
                }
            }, 300);
        }
    }, [isOpenModalSuccessKlinikKhusus]);

    return (
        <AlertDialog
            motionPreset="slideInBottom"
            leastDestructiveRef={cancelRef}
            onClose={onClose}
            isOpen={isOpenModalSuccessKlinikKhusus}
            isCentered
            size="2xl"
        >

            <AlertDialogOverlay />
            <AlertDialogContent textAlign="center" alignItems="center" position="relative">
                <canvas
                    ref={canvasRef}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        pointerEvents: 'none',
                    }}
                />

                <AlertDialogBody fontSize="sm">
                    <Text my="3" Text fontSize="xl" fontWeight="semibold">Selamat, <br /> Anda telah menyelesaikan sub tema ini!</Text>
                    <Text fontSize="sm">Silakan klik tombol di bawah ini untuk kembali ke tema utama.</Text>
                </AlertDialogBody>
                <AlertDialogFooter>
                    <Button onClick={onClose}>Kembali</Button>
                    <Button
                        colorScheme="green"
                        ml={3}
                        isLoading={loadingChangeStatusPengetahuan}
                        onClick={handleNext}
                    >
                        Lanjut
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};

export default ModalSuccessKlinikKhusus;